import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { OrganizationDetailsProps } from '../OverviewDetails.types'

import { Button, CardDashboard, CardContent, Spacer } from '@percent/lemonade'
import { EditLocationModal } from './EditLocationModal'
import { getCountryFromAlpha3 } from '@percent/admin-dashboard/common/utility/getCountryFromCountryCode'
import { useQuery, useOrganisationsAccess } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'

export function Location({ organization, refresh }: OrganizationDetailsProps) {
  const [dialogState, setDialogState] = useState(false)
  const { adminService } = useServices()
  const { t } = useTranslation()
  const handleRegistriesDialog = () => {
    setDialogState(prevState => !prevState)
  }
  const { canEditLocation } = useOrganisationsAccess()

  const [{ data: organisationDefaultLocale }] = useQuery(
    adminService.getOrganisationDefaultLocale,
    { id: organization.id },
    {
      skip: !organization.id
    }
  )

  return (
    <>
      <CardDashboard
        title={t('typography.location')}
        action={
          canEditLocation && (
            <Button onClick={handleRegistriesDialog} variant="secondary" data-testid="location-details-edit-button">
              {t('typography.editLocation')}
            </Button>
          )
        }
      >
        <CardContent title={t('typography.locale')} testId="location-details-locale">
          {organisationDefaultLocale?.defaultLocale ?? t('typography.notAvailable')}
        </CardContent>
        <CardContent title={t('typography.addressLine1')} testId="location-details-address1">
          {organization.addressLine1 || t('typography.notAvailable')}
        </CardContent>
        <CardContent title={t('typography.addressLine2')} testId="location-details-address2">
          {organization.addressLine2 || t('typography.notAvailable')}
        </CardContent>
        <CardContent title={t('typography.city')} testId="location-details-city">
          {organization.city || t('typography.notAvailable')}
        </CardContent>
        <CardContent
          testId="location-details-state"
          title={t(organization.countryCode !== 'USA' ? 'typography.countyOrState' : 'typography.state')}
        >
          {organization.state || t('typography.notAvailable')}
        </CardContent>
        <CardContent title={t('typography.postalCode')} testId="location-details-postcode">
          {organization.postcode || t('typography.notAvailable')}
        </CardContent>
        <CardContent title={t('typography.country')} testId="location-details-country">
          {getCountryFromAlpha3(organization.countryCode) || t('typography.notAvailable')}
        </CardContent>
      </CardDashboard>
      <Spacer size={6} axis="vertical" />
      <EditLocationModal
        open={dialogState}
        onClose={handleRegistriesDialog}
        organization={organization}
        refresh={refresh}
        organisationDefaultLocale={organisationDefaultLocale?.defaultLocale}
      />
    </>
  )
}
